<template>
  <div class="avatar-list">
    <avatar
      v-for="(avatar, index) in avatarsToDisplay"
      :key="index"
      :person="avatar"
      :size="size"
      :style="{ zIndex: avatarsToDisplay.length - index }"
      :show-name-on-hover="isAvatarTooltip"
    />

    <el-tooltip v-if="remainingAvatars > 0" :show-arrow="true" :disabled="!isAvatarTooltip" placement="bottom">
      <template #content>
        <div>
          <div v-for="(avatar, index) in listRemainingAvatars" :key="index">
            {{ avatar.name }}
            <br >
          </div>
          {{
            (remainingTooltipAvatars > 0)?
              `and ${remainingTooltipAvatars} more...`:
              ``
          }}
        </div>
      </template>
      <span
        :class="{'avatar-list__remain--is-link': isAvatarTooltip}"
        class="avatar-list__remain"
        @click="$emit('handleClick')"
      >{{ `+${remainingAvatars}` }}</span>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import PersonAvatar from '@/components/global/avatar.vue'

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'AvatarList',

  components: {
    PersonAvatar,
  },

  props: {
    people: {
      type: Array as () => IPersonBase[],
      required: true,
    },
    maxNumAvatars: {
      type: Number,
      default: 4,
    },
    size: {
      type: Number,
      default: 24,
    },
  },

  emits: ['handleClick'],

  data() {
    return {
      maxNumAvatarsTooltip: 7,
      isAvatarTooltip: false,
    }
  },

  computed: {
    avatarsToDisplay(): IPersonBase[] {
      const arrayToDisplay = [...this.people]
      return arrayToDisplay.splice(0, this.maxNumAvatars)
    },
    remainingAvatars(): number {
      return this.people.length - this.maxNumAvatars
    },
    listRemainingAvatars(): IPersonBase[] {
      const arrayToDisplay = [...this.people].splice(this.maxNumAvatars)
      return arrayToDisplay.splice(0, this.maxNumAvatarsTooltip)
    },
    remainingTooltipAvatars(): number {
      return (
        [...this.people].splice(this.maxNumAvatars).length -
        this.maxNumAvatarsTooltip
      )
    },
  },
})
</script>

<style lang="scss" scoped>
.avatar-list {
  &__remain {
    margin-left: 5px;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-text-third);

    &--is-link {
      cursor: pointer;

      &:hover {
        color: $color--blue;
      }
    }
  }

  .avatar {
    margin-left: -6px;
    border: solid 1px $color--white;

    &:first-of-type {
      margin-left: 0;
    }
  }
}
</style>
